import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './SearchBar.scss';
import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const SearchBar = ({
  filterText,
  onFilterTextChange,
  onSearchClick,
  handleKeyUp,
  placeholder
}) => {
  const [localText, setLocalText] = useState(filterText ?? '');
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);

  // Watch local text and debounce the parent update
  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      onFilterTextChange(localText);
    }, 500); // 500ms debounce
    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
  }, [localText]);

  useEffect(() => {
    // Sync external changes (e.g., resetting the field)
    setLocalText(filterText ?? '');
  }, [filterText]);

  return (
    <div className="search-bar">
      <input
        className="search-input"
        type="text"
        value={localText}
        placeholder={placeholder}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleKeyUp(e.target);
          }
        }}
        onChange={(e) => setLocalText(e.target.value)}
      />

      <Button
        className="search-btn"
        id="search-input"
        aria-label="search"
        name="search"
        onClick={onSearchClick}
      >
        <FontAwesomeIcon icon="search" size="lg" color="#ffffff" />
      </Button>

      <br/><br/><br/><br/>
    </div>
  );
};

export default SearchBar;
